import { Typography } from "@mui/material";
import Switch from "@mui/material/Switch";
import { useState } from "react";
import { ToggleWrapper } from "./Toggle.style";

type ToggleType = {
  label: string;
  checked: boolean;
  onToggle: (checked: boolean) => void | Promise<void>;
  disabled?: boolean;
};

const Toggle = ({ label, checked, onToggle, disabled }: ToggleType) => {
  // `checked` reflects server state, which only lands after the round-trip
  // completes, so the switch still shows the old value while a request is in
  // flight. Without this guard a second click rebuilds the same payload and the
  // http layer's duplicate-request detector rejects it.
  const [isPending, setIsPending] = useState(false);

  const handleToggle = async (nextChecked: boolean) => {
    setIsPending(true);
    try {
      await onToggle(nextChecked);
    } finally {
      setIsPending(false);
    }
  };

  return (
    <ToggleWrapper>
      <Typography data-testid="toggle-label">{label}</Typography>
      <Switch
        slotProps={{
          input: {
            "aria-label": label,
          },
        }}
        checked={checked}
        onChange={(_event, nextChecked) => handleToggle(nextChecked)}
        disabled={disabled || isPending}
      />
    </ToggleWrapper>
  );
};

export default Toggle;
